import PropTypes from 'prop-types';
import React from 'react';

class LabelErrorDirectly extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any
    };
  }

  render() {
    return <span>{this.props.children}</span>;
  }
}

export default LabelErrorDirectly;
